import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { useEffect, useState } from "react"
import { Pagination } from "../../../../components/Pagination"
import { getFechaCA } from "../../../../utils/stringDate"
import useNotaDebitoExterno from "../../../../actions/nota-debito-externo.actions"
import {enDolares, montosDeProducto} from "../../../../actions/nota-debito.actions"
import { convertirNumeroConComas } from "../../../../utils/numbers.utils"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"
import { processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions"
import FilaDistritoDTE from "../CamposV2/FilaDistritoDTE";
import FilaFusionDTE from "../CamposV2/FilaFusionDTE";
import {TIPO_DTE, versionDteEmision} from '../../../../utils/version-documento.utils'

import FilaDistritoEmisor from "../CamposV2/FilaDistritoEmisor";
export default function DTENotaDebitoExterno (){
    const {formCliente, productos, response_QRcode, view, documentosFisico} = useSelector((state: State) => state.notaDebitoExterno)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datosEmisor, tipoDocumento, tipoDocumentosEmision, actividadesEconomicas, municipios, departamentos, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)

    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const {calculosProductos} = useNotaDebitoExterno();

    const totales = calculosProductos()
    const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos)
    }, [productos])

    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>NOTA DE DÉBITO</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{versionDteEmision(TIPO_DTE.NOTA_DEBITO, datosEmisor) || ''}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
                {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{formCliente?.nombre}</td></tr>
                        <tr><td>NIT:</td><td>{formCliente?.noDocumento}</td></tr>
                        <tr><td>NRC:</td><td>{formCliente?.nrc}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === formCliente?.actividad)?.valor}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{formCliente?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                        <tr><td>Dirección:</td><td>{formCliente?.direccion}</td></tr>
                        <tr><td>Departamento:</td><td>{departamentos.find((departamento) => departamento.codigo === formCliente?.departamento)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Municipio:</td><td>{municipios.find((municipio) => municipio.codigo === formCliente?.municipio)?.valor?.toUpperCase() }</td></tr>
                        <FilaDistritoDTE distrito = {formCliente?.distrito}/>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <div className='dt-center-content'>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <FilaDistritoEmisor />
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                        <FilaFusionDTE/>
                    </table>
                </div>
                </div>
            </div>
            <div className="dte-section">
              <div className="dte-subsection">
                    <label className="dte-subsection-title">Documento de referencia</label>
                    <table className='tlu-table-main-responsive tlu-responsive-table-main td-left table-pointer' style={{marginTop: '8px'}}>
                    <thead>
                        <tr>
                            <td>Número de documento</td>
                            <td>Tipo de documento</td>
                            <td>Fecha de generación</td>
                            <td>Monto</td>
                        </tr>
                    </thead>
                    <tbody>
                        {documentosFisico.numId && <tr>
                            <td data-label='Número de documento'>{documentosFisico.numId}</td>
                            <td data-label='Tipo de documento'>{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documentosFisico.tipo)?.nombre}</td>
                            <td data-label='Fecha de generación'>{getFechaCA(documentosFisico.fecha)}</td>
                            <td data-label='Monto'>${convertirNumeroConComas(documentosFisico.monto)}</td>
                        </tr>}
                    </tbody>
                    </table>
              </div>
            </div>
            <div className="tab-plane" style={{marginTop: "25px"}}>
            <div className="table-facturacion-resp">
                <table className="table-main-responsive responsive-table-main td-left table-pointer">
                    <thead>
                        <tr>
                            <td>Cantidad</td>
                            <td>Unidad de medida</td>
                            <td>Tipo</td>
                            <td>Descripción</td>
                            <td>Precio unitario</td>
                            <td>Otros impuestos</td>
                            <td>Descuento</td>
                            <td>Ventas gravadas</td>
                            <td>Ventas exentas</td>
                        </tr>
                    </thead>
                    <tbody>
                    {tableProductos.map((producto, index) => {
                            const {precioUni, descuento, venta} = montosDeProducto(producto)
                            const detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '06', producto, venta);

                            return(
                            <tr key={index}>
                                <td data-label="Cantidad">{producto.cantidad}</td>
                                <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                <td data-label="Precio unitario">{enDolares(precioUni)}</td>
                                <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                <td data-label="Descuento">{enDolares(descuento)}</td>
                                <td data-label="Ventas gravadas">{enDolares(producto.exento ? 0 : venta)}</td>
                                <td data-label="Ventas exentas">{enDolares(producto.exento ? venta : 0)}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
                <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                <div className="cf-calculos-producto">
                    <table>
                        <tbody>
                            <tr className="cf-subtotal">
                                <td>Suma de operaciones</td>
                                <td>{enDolares(totales.sumaOperaciones)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Impuesto al Valor Agregado 13%</td>
                                <td>{enDolares(totales.iva)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Otros impuestos</td>
                                <td>{enDolares(totales.otrosImpuestos)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Subtotal</td>
                                <td>{enDolares(totales.subtotal)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>IVA percibido 1%</td>
                                <td>{enDolares(totales.ivaPercibido)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>IVA retenido 1%</td>
                                <td>{enDolares(totales.ivaRetenido)}</td>
                            </tr>
                            <tr className="cf-descuento">
                                <td>Retencion renta 10%</td>
                                <td>{enDolares(totales.retencionRenta)}</td>
                            </tr>
                            <tr className="cf-total">
                                <td>Total</td>
                                <td>{enDolares(totales.total)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}